import { gql } from "@apollo/client"
import { DOCK_FRAG } from "./dock.fragments.gql"
export const ADD_UPDATE_DOCK = gql`
  mutation DockAddUpdate(
    $address: AddressInput
    $archive: Boolean
    $codename: String
    $depotId: ID
    $distributionCentreId: ID
    $id: ID
    $name: String
  ) {
    addUpdateDock(
      address: $address
      archive: $archive
      codename: $codename
      depotId: $depotId
      distributionCentreId: $distributionCentreId
      id: $id
      name: $name
    ) {
      dock {
        ...DockFrag
      }
    }
  }
  ${DOCK_FRAG}
`
